import empresa from '@/app-modulo/comuns/empresa/shared/store'
import empresaExGlobal from '@/shared/components/empresa-usuario-externo-select/shared/store'
import cadastroBase from '@/shared/components/cadastro-base/shared/store'
import listas from '@/app-modulo/comercial/proposta/shared/store'
import proposta from '@/app-modulo/comercial/cadastro-proposta/shared/store'
import uploadLote from '@/app-modulo/documento/portal-documentos-externo/shared/store'

export default {
  empresaExGlobal,
  empresa,
  cadastroBase,
  listas,
  proposta,
  uploadLote,
}
